module.exports = __webpack_public_path__ + "media/images/icons/arrow-up-722d194fedf69faa2f6050a2c9f55f76.svg";